import { MessageCircle } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const communicatieManifest: ModuleDefinition = {
  id: 'communicatie',
  name: 'Communicatie',
  icon: <MessageCircle size={20} />,
  color: 'var(--brand-primary)',
  basePath: '/communicatie',
  status: 'active',
  navItems: [
    { label: 'Inbox', path: '/communicatie', icon: '💬' },
    { label: 'Email', path: '/communicatie/email', icon: '✉️' },
    { label: 'Berichten', path: '/communicatie/chat', icon: '💭' },
    { label: 'Dashboard', path: '/communicatie/dashboard', icon: '📊' },
    { label: 'Analytics', path: '/communicatie/analytics', icon: '📈' },
    { label: 'Campagnes', path: '/communicatie/campagnes', icon: '📣' },
    { label: 'Templates', path: '/communicatie/templates', icon: '📧' },
    { label: 'Zoeken', path: '/communicatie/zoeken', icon: '🔍' },
    { label: 'Workflows', path: '/communicatie/workflows', icon: '⚡' },
    { label: 'WhatsApp', path: '/communicatie/instellingen/whatsapp', icon: '📱' },
    { label: 'Chatbot', path: '/communicatie/instellingen/chatbot', icon: '🤖' },
    { label: 'Feedback', path: '/communicatie/feedback', icon: '⭐' },
    { label: 'Templates', path: '/communicatie/comm-templates', icon: '📋' },
    { label: 'Escalaties', path: '/communicatie/escalaties', icon: '🚨' },
    { label: 'Audit', path: '/communicatie/audit', icon: '🛡️' },
  ],
  component: () => import('./index.js'),
};

export default communicatieManifest;
